module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div"
  }, [(_vm.scenarioNamesSelection) ? _c('div', [_c('label', {
    attrs: {
      "for": "scenarioNamesSelect"
    }
  }, [_vm._v("Scenarios to Include")]), _vm._v(" "), _c('div', [_c('uiv-multi-select', {
    attrs: {
      "disabled": _vm.scenarioNamesSelection.length == 0,
      "options": _vm.scenarioNamesSelection,
      "label-key": "label",
      "label-value": "name",
      "id": "scenarioNamesSelect"
    },
    model: {
      value: (_vm.selectedScenarioNames),
      callback: function($$v) {
        _vm.selectedScenarioNames = $$v
      },
      expression: "selectedScenarioNames"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-10a87aba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10a87aba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-scenario-chooser/model-scenario-chooser.vue.html
// module id = 1078
// module chunks = 0